import { render, staticRenderFns } from "./GifSettingsRatios.vue?vue&type=template&id=6b1da2e8&scoped=true&"
import script from "./GifSettingsRatios.vue?vue&type=script&setup=true&lang=ts&"
export * from "./GifSettingsRatios.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./GifSettingsRatios.vue?vue&type=style&index=0&id=6b1da2e8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1da2e8",
  null
  
)

export default component.exports